import { memo, useMemo, useCallback } from 'react';
import cn from 'classnames';

import styles from './BreadcrumbItem.module.scss';

interface IBreadcrumbItemProps {
  name: string;
  onClick?: () => void;
}

export const BreadcrumbItem = memo(({ name, onClick }: IBreadcrumbItemProps) => {
  const isEnabled = useMemo(() => !!onClick, [onClick]);
  const onItemClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <li className={styles.BreadcrumbItem}>
      {isEnabled ? (
        <button
          className={cn(styles.BreadcrumbItemLink, styles.BreadcrumbItemLinkEnabled)}
          onClick={onItemClick}
          type="button"
        >
          {name}
        </button>
      ) : (
        <span className={styles.BreadcrumbItemLink}>{name}</span>
      )}
    </li>
  );
});
